import React from "react"
import { notification } from "antd"
import api from "src/api"
import moment from "moment";

export function useManageItems(
    getIntervalSettings,
    settingItems,
    onSuccessCreate,
    onSuccessEdit
) {

  const [editData, setEditData] = React.useState(null)

  function onEditItem(id) {
    const item = settingItems.find((el) => el.id === id)
    const newItem = {
      key: id,
      id,
      date: item.date ? moment(item.date, "YYYY-MM-DD") : null,
      pointIds: item.pointIds || [],
      intervals: (item.intervals || []).map((interval) => ({
        start: interval?.start
            ? moment(interval.start, ["HH:mm:ss", "HH:mm"])
            : null,
        end: interval?.end
            ? moment(interval.end, ["HH:mm:ss", "HH:mm"])
            : null,
      })),
    }
    setEditData(newItem)
    onSuccessEdit()
  }

  async function onCreate(values) {
    try {
      await api.post("custom-intervals", values)

      notification.success({ message: "Интервалы настроены" })

      onSuccessCreate()
      getIntervalSettings()

    } catch (error) {
      notification.error({ message: "Ошибка записи настроек" })
      throw error
    }
  }

  async function onEdit(values, id) {
    try {
      await api.post(`custom-intervals/${id}`, values)

      notification.success({ message: "Интервалы настроены" })
      onSuccessEdit()
      setEditData(false)
      getIntervalSettings()

    } catch (error) {
      notification.error({ message: "Ошибка записи настроек" })
      throw error
    }
  }

  async function onDelete(id) {
    try {
      const form = new FormData;
      form.append("id", id)
      form.append("_method", "DELETE")
      await api.post(`custom-intervals/${id}`, form)

      notification.success({ message: "Настроека удалена" })
      getIntervalSettings()
    } catch (error) {
      notification.error({ message: "Ошибка удаления" })
      throw error
    }
  }

  return { onCreate, onDelete, onEditItem, editData, onEdit }
}
